/** Offline A4 export. Codes stay in browser memory and are never sent to a PDF service. */
export function downloadBackupCodesPdf(codes: string[], title: string, intro: string) {
  const canvas = document.createElement('canvas');
  // 300 dpi A4 keeps diacritics and code characters sharp when printed.
  canvas.width = 2480;
  canvas.height = 3508;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Canvas unavailable');
  ctx.scale(canvas.width / 595.28, canvas.height / 841.89);
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, 595.28, 841.89);
  ctx.fillStyle = '#17263b';
  ctx.font = 'bold 17px sans-serif';
  ctx.fillText('Smart Measure · NENASAL', 48, 65);
  ctx.font = 'bold 25px sans-serif';
  ctx.fillText(title, 48, 114);
  ctx.font = '12px sans-serif';
  let line = '';
  let y = 147;
  for (const word of intro.split(/\s+/)) {
    const next = line ? `${line} ${word}` : word;
    if (ctx.measureText(next).width > 490 && line) {
      ctx.fillText(line, 48, y);
      y += 19;
      line = word;
    } else line = next;
  }
  ctx.fillText(line, 48, y);
  y += 45;
  ctx.font = '18px monospace';
  codes.forEach((code, i) => {
    const x = i % 2 ? 310 : 48;
    const rowY = y + Math.floor(i / 2) * 48;
    ctx.strokeStyle = '#c4cad2';
    ctx.strokeRect(x, rowY - 13, 12, 12);
    ctx.fillText(code, x + 24, rowY);
  });
  ctx.font = '10px sans-serif';
  ctx.fillText(new Date().toLocaleString(), 48, 790);
  ctx.fillText('smartmeasure.app', 442, 790);

  const jpeg = Uint8Array.from(atob(canvas.toDataURL('image/jpeg', 0.98).split(',')[1]!), (c) =>
    c.charCodeAt(0),
  );
  // Minimal single-page PDF: one JPEG XObject, with byte-accurate cross-reference offsets.
  const encoder = new TextEncoder();
  const chunks: Uint8Array[] = [];
  const offsets = [0];
  let size = 0;
  const append = (value: string | Uint8Array) => {
    const bytes = typeof value === 'string' ? encoder.encode(value) : value;
    chunks.push(bytes);
    size += bytes.byteLength;
  };
  const object = (id: number, body: string) => {
    offsets[id] = size;
    append(`${id} 0 obj\n${body}\nendobj\n`);
  };
  append('%PDF-1.4\n');
  object(1, '<< /Type /Catalog /Pages 2 0 R >>');
  object(2, '<< /Type /Pages /Kids [3 0 R] /Count 1 >>');
  object(
    3,
    '<< /Type /Page /Parent 2 0 R /MediaBox [0 0 595.28 841.89] /Resources << /XObject << /Im0 5 0 R >> >> /Contents 4 0 R >>',
  );
  const content = 'q 595.28 0 0 841.89 0 0 cm /Im0 Do Q\n';
  object(4, `<< /Length ${content.length} >>\nstream\n${content}endstream`);
  offsets[5] = size;
  append(
    `5 0 obj\n<< /Type /XObject /Subtype /Image /Width ${canvas.width} /Height ${canvas.height} /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ${jpeg.length} >>\nstream\n`,
  );
  append(jpeg);
  append('\nendstream\nendobj\n');
  const xref = size;
  append(
    `xref\n0 6\n0000000000 65535 f \n${offsets
      .slice(1)
      .map((offset) => `${String(offset).padStart(10, '0')} 00000 n \n`)
      .join('')}trailer\n<< /Size 6 /Root 1 0 R >>\nstartxref\n${xref}\n%%EOF\n`,
  );
  const url = URL.createObjectURL(new Blob(chunks as BlobPart[], { type: 'application/pdf' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = 'smart-measure-rezervni-kodovi.pdf';
  link.click();
  canvas.width = canvas.height = 0;
  // Give the browser time to consume the download before releasing its object URL.
  setTimeout(() => URL.revokeObjectURL(url), 30_000);
}
